import { getDashboardTourSteps } from '../tours/dashboardTour';
import { getSearchTourSteps } from '../tours/searchTour';
import { getChatTourSteps } from '../tours/chatTour';
import { getContractTourSteps } from '../tours/contractTour';
import { getLegalNewsTourSteps } from '../tours/legalNewsTour';
import { getAnnonceLegaleTourSteps } from '../tours/annonceLegaleTour';
import { getSettingsTourSteps } from '../tours/settingsTour';

/**
 * Registry of all onboarding tours.
 * Each entry maps a tourId to its route, step generator, and feature gate.
 */
const TOUR_REGISTRY = {
  dashboard: {
    route: '/',
    getSteps: getDashboardTourSteps,
    featureGate: null,
  },
  search: {
    route: '/search',
    getSteps: getSearchTourSteps,
    featureGate: null,
  },
  chat: {
    route: '/conversation',
    getSteps: getChatTourSteps,
    featureGate: null,
  },
  contract: {
    route: '/contract',
    getSteps: getContractTourSteps,
    featureGate: 'contract_module',
  },
  legalNews: {
    route: '/legal-news',
    getSteps: getLegalNewsTourSteps,
    featureGate: 'news_hub',
  },
  annonceLegale: {
    route: '/legal-notice',
    getSteps: getAnnonceLegaleTourSteps,
    featureGate: null,
  },
  settings: {
    route: '/settings',
    getSteps: getSettingsTourSteps,
    featureGate: null,
  },
};

export default TOUR_REGISTRY;
